import BenefitsSection from './BenefitsSection'

export default BenefitsSection
